export default __webpack_public_path__ + "static/media/icon-dinning-room-inverted.f01f6037.svg";